import React from 'react';
import {
  ButtonBack,
  ContainerProcedure,
  SubContainer
} from '../../../certificates-constancies/type1/info/components';
import {
  TextTitle,
  ToggleHeader
} from '../../../certificates-constancies/type1/register/components';
import { Block } from '../../../../../../components';
import Step from '../../UpdatePhoto/Register/components/Step';
import RegisterForm from './components/RegisterForm';
import Spinner from '../../../../../../components/Spinner';
import ModalConfirmation from '../../../../components/Modal/Modal';
import ContentModalTwoButtons from '../../../../components/ContentModalTwoButtons';
import Processing from '@/presentation/components/Processing';
import ContentModalOneButton from '../../../../components/ContentModalOneButton';
import errorIcon from '../../../../../../../assets/icons/illustration.svg';
import ExchangeOptions from './components/ExchangeOptions';
import {
  ProcedureInfoComponent,
  StepsToFollowComponent
} from '../info/components/ProcedureInfoComponent';

interface ReincorporationRegisterViewProps {
  confirm: { showConfirm: boolean; setShowConfirm: (confirm: boolean) => void };
  error: { showError: boolean; setShowError: (error: boolean) => void };
  isProcessingProgramByCampus: boolean;
  isProcessingRegister: boolean;
  isVirtual: boolean;
  isVirtualChange: boolean;
  procedureInfo: any;
  profileInfo: any;
  programByCampus: any;
  selectedPeriod: any;
  step: { currentStep: number; setCurrentStep: (step: number) => void };
  getProgramByCampus: (campusId: string) => void;
  onBackButton: () => void;
  onChangePeriod: (element: any) => void;
  onRegisterRequest: () => void;
  registerWithoutChanges: () => void;
  registerWithChanges: (params: any) => void;
  setIsVirtualChange: (value: boolean) => void;
  isPPE: boolean;
}

const ReincorporationRegisterView = ({
  confirm,
  error,
  isProcessingProgramByCampus,
  isProcessingRegister,
  isVirtual,
  isVirtualChange,
  procedureInfo,
  profileInfo,
  programByCampus,
  selectedPeriod,
  step,
  isPPE,
  getProgramByCampus,
  onBackButton,
  onChangePeriod,
  onRegisterRequest,
  registerWithoutChanges,
  registerWithChanges,
  setIsVirtualChange
}: ReincorporationRegisterViewProps) => {
  const { showConfirm, setShowConfirm } = confirm;
  const { currentStep, setCurrentStep } = step;
  const { showError, setShowError } = error;

  const closeModalError = () => {
    setShowError(false);
    setShowConfirm(false);
  };

  const goToStepTwo = () => {
    setCurrentStep(2);
    setShowConfirm(false);
  };

  const closeConfirmation = () => setShowConfirm(false);

  return (
    <ContainerProcedure>
      <Processing
        isOpen={isProcessingRegister}
        text="No cierres esta ventana"
      />
      <ButtonBack onClick={onBackButton} />
      {!procedureInfo && <Spinner />}
      {procedureInfo && (
        <SubContainer>
          <ToggleHeader
            name={procedureInfo?.name}
            amount={procedureInfo?.amount}
            duration={procedureInfo?.duration}
            date={procedureInfo?.endDate}
            childContent={
              <>
                <ProcedureInfoComponent inRegister />
                <br />
                <StepsToFollowComponent />
              </>
            }
            twoLineFormat
            inRegister
          />
          <TextTitle title="Progreso" />
          <Block customized padding="28px 0px 45px 8px">
            <Step
              name={procedureInfo?.steps[0]?.name}
              order={procedureInfo?.steps[0]?.order}
              isCurrent={currentStep === 1}
              isComplete={currentStep === 2}
            >
              {currentStep === 1 ? (
                <RegisterForm
                  optionsPeriod={procedureInfo?.detail?.periodApplied?.map(
                    (p: any) => ({
                      value: p.id,
                      name: p.name
                    })
                  )}
                  selectedPeriod={selectedPeriod}
                  changePeriod={onChangePeriod}
                  onSubmit={onRegisterRequest}
                  profileInfo={profileInfo}
                />
              ) : (
                <>{selectedPeriod?.name}</>
              )}
            </Step>
            <Step
              name={procedureInfo?.steps[1]?.name}
              order={procedureInfo?.steps[1]?.order}
              disabled={currentStep === 1}
              isCurrent={currentStep === 2}
            >
              {currentStep === 2 && (
                <ExchangeOptions
                  isPPE={isPPE}
                  currentData={procedureInfo?.detail}
                  getProgramByCampus={getProgramByCampus}
                  isProcessingProgramByCampus={isProcessingProgramByCampus}
                  isVirtual={isVirtual}
                  isVirtualChange={isVirtualChange}
                  onChanges={(v) => registerWithChanges(v)}
                  onNotChanges={() => registerWithoutChanges()}
                  programByCampus={programByCampus}
                  setIsVirtualChange={setIsVirtualChange}
                />
              )}
            </Step>
            <Step
              name={procedureInfo?.steps[2]?.name}
              order={procedureInfo?.steps[2]?.order}
              disabled
            />
            <Step
              name={procedureInfo?.steps[3]?.name}
              order={procedureInfo?.steps[3]?.order}
              isLast
              disabled
            />
          </Block>
          {/* Confirm */}
          <ModalConfirmation
            show={showConfirm && !isProcessingRegister && !showError}
            handleClose={closeConfirmation}
          >
            <ContentModalTwoButtons
              align="left"
              img={null}
              title="Opciones de cambio"
              subtitle={`Actualmente te encuentras en:<br /> 
              <ul style="list-style: outside; padding-left: 20px;">
              <li style="display: ${
                isVirtual ? 'none' : 'list-item'
              }">Campus: ${procedureInfo?.detail?.currentAcademicData?.campus?.name?.toUpperCase()}</li>
              <li>Carrera: ${procedureInfo?.detail?.currentAcademicData?.program?.name?.toUpperCase()}</li>
              <li>Modalidad: ${
                isPPE
                  ? 'SEMIPRESENCIAL'
                  : procedureInfo?.detail?.currentAcademicData?.studiesOption?.modalityName?.toUpperCase()
              }</li>
              </ul>
              <br />
              ¿Deseas reincorporarte con algún cambio?`}
              showInfo={false}
              textButton1="Sin cambios"
              textButton2="Realizar cambios"
              onClickButton1={registerWithoutChanges}
              onClickButton2={goToStepTwo}
            />
          </ModalConfirmation>
          {/* Error */}
          <ModalConfirmation show={showError} handleClose={closeModalError}>
            <ContentModalOneButton
              center
              img={errorIcon}
              title="¡Oh no!<br/>
              Ha sucedido un error inesperado"
              showInfo={false}
              textButton="Entendido"
              onClickButton={closeModalError}
            />
          </ModalConfirmation>
        </SubContainer>
      )}
    </ContainerProcedure>
  );
};

export default ReincorporationRegisterView;
